import { render, staticRenderFns } from "./billBuy.vue?vue&type=template&id=88c7d2a6&"
import script from "./billBuy.vue?vue&type=script&lang=js&"
export * from "./billBuy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports